import * as Raven from "raven-js";
import Config from "../Config/Config";

const shouldTrackAnalytics = Config.shouldTrackAnalytics();
const url = Config.ravenUrl();
if (url && shouldTrackAnalytics) {
  Raven.config(url, {
    release: "0-0-0"
  }).install();
}

// TODO: upload source
// TODO: connect to redux events

export default class RavenService {
  public static captureException(error: Error, errorInfo: any) {
    if (!shouldTrackAnalytics) {
      console.error(error);
      return;
    }
    Raven.captureException(error, { extra: errorInfo });
  }

  public static captureMessage(msg: string) {
    if (!shouldTrackAnalytics) {
      console.error(msg);
      return;
    }
    Raven.captureMessage(msg);
  }
}



// WEBPACK FOOTER //
// ./src/services/Logging/RavenService.ts